module.exports = __webpack_public_path__ + "img/yx(7).8159c4ca.png";